/**
 * defa.collections.RoleApplications
 * A collection of RoleApplication models.
 * @version 1.0.0
 */

import { defa }            from 'defa-object';
import { RoleApplication } from './model-role-application';

const apiHost = defa.vars.apiHost;

export const RoleApplications = Bb.Collection.extend( {
	model: RoleApplication,
	
	url  : function () {
		return apiHost + '/roleapplications';
	},
	
	
	fetchAllRoleApplications: function ( options ) {
		this.fetch( {
			url: this.url(),
			reset: true, // Triggers a reset event when all models are fetched
			error: function(collection, response){
				options.error(response);
			},
		} );
		
	},
} );

export default RoleApplications;